// Candidate-flow calls must carry the token issued after OTP verification
// (ScheduleTest.jsx stores it per interview in sessionStorage). The backend
// rejects candidate routes without it (401) or scoped to another interview (403).
export const getCandidateToken = (interviewId) =>
  sessionStorage.getItem(`candidateToken_${interviewId}`);

export const candidateAuthHeader = (interviewId) => {
  const token = getCandidateToken(interviewId);
  return token ? { Authorization: `Bearer ${token}` } : {};
};
